import { Tooltip } from "@mantine/core"
import { useHover } from "@mantine/hooks"
import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { NavItem } from "../../layout/NavBar/AppNavBar.tsx"
import { isNotNullRef } from "../../utils/typeguard.ts"

import styles from "./NavBarItem.module.css"

type Props = {
  item: NavItem
}

export const NavBarItem = ({ item }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { ref, hovered } = useHover<HTMLDivElement>()

  const isActive = useMemo(() => {
    if (item.link === "/") return location.pathname === "/"
    return location.pathname.includes(item.link)
  }, [item.link, location.pathname])

  return (
    <Tooltip label={item.label} position="right">
      <div
        ref={isNotNullRef(ref) ? ref : undefined}
        onClick={() => navigate(item.link)}
        className={`${styles.navItem} ${isActive ? styles.active : ""}`}
      >
        <item.Icon width={28} hovered={isActive || hovered} />
      </div>
    </Tooltip>
  )
}
